import { render, staticRenderFns } from "./PageBasicDialogForm.vue?vue&type=template&id=d664f67a&scoped=true&"
import script from "./PageBasicDialogForm.vue?vue&type=script&lang=js&"
export * from "./PageBasicDialogForm.vue?vue&type=script&lang=js&"
import style0 from "./PageBasicDialogForm.vue?vue&type=style&index=0&id=d664f67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d664f67a",
  null
  
)

export default component.exports